/**
 * this is the controller to handle actions and settings in the menu bar
 **/
export default class MenuBarController {
	/**
	 * define required services here
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector, $scope) {
		this.$scope = $scope;
		this.Socket = $injector.get('socket');
		this.ToastService = $injector.get('ToastService');
		this.$storage = $injector.get('$localStorage');
		this.$sessionStorage = $injector.get('$sessionStorage');
		_ = $injector.get('_');
	}

	/**
	 * initialize the component and define some models
	 **/
	$onInit() {
		/*
		 *  Example Object:
		 * 	{
		 *		headline: myHeadline,
		 *		subheadline: mySubheadline,
		 *		text: myText
		 *	}
		 */
		this.$storage.notifications = this.$storage.notifications || [];
		this.removeNotificationItemOlderThan(8);
		this.handleNotificationItemLimitation(15);

		this.registerEvents();
	}

	/**
	 * initialize the component and define some models
	 * @param {Object} notification - Object with headline, subheadline and text
	 **/
	add(notification) {
		notification.timestamp = new Date();
		this.$storage.notifications.push(notification);
		this.handleNotificationItemLimitation(15);
	}

	/**
	 * register events
	 **/
	registerEvents() {
		this.$scope.$on('menu-bar:notification:add', (events, notification) => {
			this.add(notification);
			this.Socket.emit('socket:menu-bar:notification:add', notification);
		});

		this.Socket.on('socket:menu-bar:notification:add', (notification) => {
			this.add(notification);
		});
	}

	/**
	 * remove notifications older then {hours} to prevent the localStorage from flooding
	 * @param {number} hours - Items older than this amount will be removed
	 **/
	removeNotificationItemOlderThan(hours) {
		const pastDate = new Date(new Date().getTime() - 60 * 60 * hours * 1000);

		_.remove(this.$storage.notifications, (obj) => {
			const timestamp = new Date(obj.timestamp);
			return timestamp.getTime() < pastDate.getTime();
		});
	}

	/**
	 * remove oldest notifications if storage count more then {count} to prevent the localStorage from flooding
	 * @param {number} count - amount of items to keep in the storage
	 **/
	handleNotificationItemLimitation(count) {
		const countItems = this.$storage.notifications.length;

		if (countItems > count) {
			this.$storage.notifications = _.takeRight(this.$storage.notifications, count);
		}
	}

	/**
	 * remove all notifications from localStorage
	 **/
	removeAllNotificationItems() {
		this.$storage.notifications = [];
	}

	/**
	 * remove all listeneres on destroy
	 **/
	$onDestroy() {
		this.Socket.removeAllListeners('socket:menu-bar:notification:add');
	}
}
